import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, Heading, Spinner, HStack } from '@chakra-ui/react';
import FeatureToggles from './feature_toggle/FeatureToggles';
import FeatureToggleForm from './feature_toggle/FeatureToggleForm';
import AdminDashboard from './AdminDashboard';
import TourLeadsList from './tour_leads/TourLeadsList';
import ConsultantsList from './consultants/ConsultantsList';
import ConsultantCreatePage from './consultants/ConsultantCreatePage';
import ConsultantEditPage from './consultants/ConsultantEditPage';
import LeadsList from '../leads/LeadsList';
import LeadShowPage from '../leads/LeadDetails';
import AdminNetworksListPage from './networks/AdminNetworksListPage';
import AdminNetworkDetailPage from './networks/AdminNetworkDetailPage';
import { useUser } from '../../contexts/UserContext';
import {
  canAccessAdminSection,
  canManageConsultantsAdmin,
  canViewFeatureToggles,
  canViewLeadsAdmin,
} from '../../utils/authorization';

const AccessDenied = () => (
  <Box p={6}>
    <Heading size="md">Access Denied</Heading>
  </Box>
);

const AdminRoutes = () => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <HStack justify="center" py={12}><Spinner size="lg" /></HStack>;
  }

  if (!canAccessAdminSection(user)) {
    return <AccessDenied />;
  }

  const canFeatureToggles = canViewFeatureToggles(user);
  const canLeads = canViewLeadsAdmin(user);
  const canConsultants = canManageConsultantsAdmin(user);

  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/feature-toggles" element={canFeatureToggles ? <FeatureToggles /> : <AccessDenied />} />
      <Route path="/feature-toggles/create" element={canFeatureToggles ? <FeatureToggleForm /> : <AccessDenied />} />
      <Route path="/feature-toggles/edit/:id" element={canFeatureToggles ? <FeatureToggleForm /> : <AccessDenied />} />
      <Route path="/tour-leads" element={canLeads ? <TourLeadsList /> : <AccessDenied />} />
      <Route path="/consultants" element={canConsultants ? <ConsultantsList /> : <AccessDenied />} />
      <Route path="/consultants/new" element={canConsultants ? <ConsultantCreatePage /> : <AccessDenied />} />
      <Route path="/consultants/:id" element={canConsultants ? <ConsultantEditPage /> : <AccessDenied />} />
      <Route path="/leads" element={canLeads ? <LeadsList /> : <AccessDenied />} />
      <Route path="/leads/:id" element={canLeads ? <LeadShowPage /> : <AccessDenied />} />
      <Route path="/networks" element={<AdminNetworksListPage />} />
      <Route path="/networks/:id" element={<AdminNetworkDetailPage />} />
    </Routes>
  );
};

export default AdminRoutes;
